
import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const flags = {
  'cs': '🇨🇿', // Czech flag
  'sk': '🇸🇰', // Slovak flag
};

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="flex items-center gap-1 h-9 min-w-[90px] justify-center">
          <Globe className="h-4 w-4 mr-1" />
          {flags[language]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem 
          disabled={language === 'cs'} 
          onClick={() => setLanguage('cs')}
          className="cursor-pointer flex items-center justify-between"
        >
          <span>Čeština</span>
          {flags['cs']}
        </DropdownMenuItem>
        <DropdownMenuItem 
          disabled={language === 'sk'} 
          onClick={() => setLanguage('sk')}
          className="cursor-pointer flex items-center justify-between"
        >
          <span>Slovenčina</span>
          {flags['sk']}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;

